import React, { useState, useRef } from "react";
import { IonApp, IonCard, IonContent, IonHeader, IonIcon, IonItem, IonLabel, IonList, IonMenu, IonMenuToggle, IonPage, IonRadio, IonRadioGroup, IonTitle, IonToolbar } from '@ionic/react';
import topics from "../../menus/Olympiad/ClassOne";
import Header from "../../pages/Header";
import Footer from "../../pages/Footer";

const NSO: React.FC = () => {

    const handleSubmit = (url: string) => {
        window.location.href = url;
    }

    document.title = "Mamas Guidance - Olympiad - Class One"

    return (
        <IonContent>
            <Header />
            <IonCard className='privacy-policy-section'>
                <h1 className='text-center font-50'>NSO</h1>
                <p className="mt-5">
                    <strong>NSO (National Science Olympiad)</strong> is a science-based competitive exam organized by the 
                     &nbsp;<strong>Science Olympiad Foundation (SOF)</strong> for students from Class 1 to 12.
                    It aims to develop <em>scientific reasoning, awareness,</em> and
                    <em>analytical thinking</em> in children through engaging and concept-based questions beyond the regular school curriculum.
                </p>
                <div className='mt-5'>
                    <div className="classes-grid">
                        <div className="olympiad-card nso">
                            <h3>Class One</h3>
                            <p>It covers plants, animals, human body, food, housing, air, water, transport, weather, space.</p>
                            <a href="/olympiad-classone/nso">Start Now</a>
                        </div>
                        <div className="olympiad-card nso">
                            <h3>Class Two</h3>
                            <p>It covers plants, animals, human body and health, food, housing and clothing, air, water, transport, communication, weather, Earth and sky.</p>
                            <a href="/olympiad-classtwo/nso">Start Now</a>
                        </div>
                        <div className="olympiad-card nso">
                            <h3>Class Three</h3>
                            <p>It covers topics like Plants, Animals, Human Body, Food, Water, Air, Weather, Earth, Sun, Light, Sound, Matter, and Science in Daily Life.</p>
                            <a href="/olympiad-classthree/nso">Start Now</a>
                        </div>
                    </div>
                </div>
            </IonCard>
            <Footer />
        </IonContent>
    );
};
export default NSO;